export * from "./types.js";
export * from "./copy.js";
export { rentAssistanceEstimate, attachCheck } from "./calculate.js";
export { rates_2026_03_20 } from "./rates-2026-03-20.js";

import type { CraRateSet } from "./types.js";
import { rates_2026_03_20 } from "./rates-2026-03-20.js";

/**
 * Registry of CRA rate sets, keyed by their effective (indexation) date. CRA
 * indexes biannually on 20 March + 20 September; each date gets its own rate
 * file. Historical periods stay registered so a backdated estimate resolves
 * against the rates in force on the assessed date (ruleset immutability).
 *
 * Only the 20 Mar 2026 period is registered today; prior indexation dates can be
 * added as `rates-YYYY-MM-DD.ts` files without touching shipped ones.
 */
export const RENT_ASSISTANCE_RATESETS: Record<string, CraRateSet> = {
  "2026-03-20": rates_2026_03_20,
};

/** The rate sets, newest first — for date resolution. */
const RATESETS_DESC: readonly CraRateSet[] = Object.values(
  RENT_ASSISTANCE_RATESETS,
).sort((a, b) => (a.effectiveFrom < b.effectiveFrom ? 1 : -1));

/**
 * Resolve the CRA rate set in force on an ISO date (YYYY-MM-DD). Pure string
 * comparison — ISO dates sort lexically. Picks the most recent period whose
 * `[effectiveFrom, effectiveTo]` window contains the date (an open `effectiveTo`
 * of `null` extends to "now"). Throws if the date predates the earliest period.
 */
export function rentAssistanceRatesForDate(isoDate: string): CraRateSet {
  for (const set of RATESETS_DESC) {
    const afterStart = isoDate >= set.effectiveFrom;
    const beforeEnd = set.effectiveTo === null || isoDate <= set.effectiveTo;
    if (afterStart && beforeEnd) return set;
  }
  throw new Error(`no CRA rate set registered for date ${isoDate}`);
}

/** The current (most recent) CRA rate set — default for live "now" estimates. */
export const RENT_ASSISTANCE_CURRENT_RATESET: CraRateSet = rates_2026_03_20;
